import Config from "../config/main";
import cookie from 'react-cookie';

let checkSportsBookView = (routerParams, selectedType, geoData) => {
    let path = window.location.pathname,
        timeTypeVersions = ["live", "prematch", "today"],
        asianFromConfig = Config.main.sportsbookViews && Config.main.sportsbookViews.includes("asian"),
        asianFromUrl = path.includes("asian"),
        asianFromCookie = cookie.load("sportsbookView") === "asian",
        classicFromConfig = Config.main.sportsbookViews && Config.main.sportsbookViews.includes("classic") || !Config.main.sportsbookViews,
        classicFromCookie = cookie.load("sportsbookView") === "classic",
        restrictedDomainPrefix = path.includes("live-casino"),
        checkedViewType,
        asianCountries = Config.main.asianCountries || [],
        viewType,
        newPath,
        i = 0;

    switch (true) {
        case !cookie.load("sportsbookView") && (geoData && geoData.countryCode) && asianCountries.includes(geoData.countryCode):
        case !(asianFromCookie || classicFromCookie) && (asianFromConfig && asianFromUrl):
        case (classicFromCookie && !classicFromConfig) && (asianFromConfig && Config.main.sportsbookViews[0] === "asian"):
            cookie.save('sportsbookView', 'asian', {path: '/'});
            break;
        default:
            break;
    }

    viewType = cookie.load("sportsbookView") || (Config.main.sportsbookViews && Config.main.sportsbookViews[0]);
    checkedViewType = (asianFromConfig && viewType === "asian") ? "asian" : "classic";

    if (!selectedType) {
        for (; i < timeTypeVersions.length; ++i) {
            if (!restrictedDomainPrefix && path.includes(timeTypeVersions[i])) {
                selectedType = timeTypeVersions[i];
                break;
            } else {
                selectedType = "prematch";
            }
        }
    }
    switch (checkedViewType) {
        case "asian":
            newPath = path.replace(selectedType, `asian_${selectedType}`);
            return {
                isAsian: true,
                mainUrl: "/",
                viewType: "asian",
                selectedTimeType: selectedType,
                homePageGamesUrl: "asian_",
                sportsItemsUrl: (`asian_${selectedType}`),
                isFavorite: path.includes("favorite"),
                isTv: path.includes("-tv"),
                newUrl: routerParams && (routerParams.regionAlias && routerParams.competitionId) ? newPath.replace(`/${routerParams.regionAlias}/${routerParams.competitionId}`, "") : newPath
            };
        default:
            newPath = (selectedType === "today") ? path.replace(`asian_${selectedType}`, "prematch") : path.replace(`asian_${selectedType}`, selectedType);
            return {
                isClassic: true,
                mainUrl: "/",
                viewType: "classic",
                selectedTimeType: selectedType,
                homePageGamesUrl: "",
                sportsItemsUrl: selectedType || newPath,
                isFavorite: path.includes("favorite"),
                isTv: path.includes("-tv"),
                newUrl: newPath
            };
    }
};
export default checkSportsBookView;